import React from 'react';
import style from './SimpleBox.module.scss';

type SimpleListItemProps = {
  children: React.ReactNode;
};
export function SimpleBox({ children }: SimpleListItemProps): React.JSX.Element {
  return (
    <div className={[style.Box, 'flex w-100 p-3'].join(' ')}>
      <div>{children}</div>
    </div>
  );
}
